module.exports = __webpack_public_path__ + "img/_circleWhiteUser2x.png?29577bbbe3136a3074c06910ea583edd";